module.exports = __webpack_public_path__ + "img/gallery04.65072512.jpg";